import React from 'react'
import Breadcrum from '../../components/breadcrum'
import AddInsight from '../../components/AddInsight'
import { useLocation, useParams } from 'react-router-dom'
import { createLatest, getLatestById, updateLatest } from '../../api/latestApi'

const AddLatestDeal = () => {
  const { id } = useParams()
  const location = useLocation()

  const isEdit = location.pathname.includes('edit') || !!id

  return (
    <>
      <Breadcrum
        heading="Insight"
        subheading={isEdit ? 'Edit latest deal' : 'Add latest deal'}
      />
      <AddInsight
        insightId={id}
        isEdit={isEdit}
        insightType="latestDeal"
        apiConfig={{
          createFn: createLatest,
          updateFn: updateLatest,
          getFn: getLatestById,
        }}
      />
    </>
  )
}

export default AddLatestDeal
